import { Breadcrumb } from "@refinedev/mui";
import { Box } from "@mui/material";
import PageHeading from "../../components/pageHeading";
export const ParentsAttendingSMCMeetings = () => {
  return (
    <Box>
      <Breadcrumb />
      <PageHeading heading="Parents attending SMC meetings (%)" />
    </Box>
  );
};
